function Reports(props) {
    return (<>
    Reports 
    <h2>
        Work In Progress
    </h2>
    </>  );
}

export default Reports;